import React from 'react'

export const DiagonalConnectionTwo = ({idCenario = 0, distance}) => {
    return (
        <>
            {idCenario===0 && <div id={444} className='diagonal-connection-two' align="center" >{distance}</div>}
            {idCenario===1 && <div id={444} className='diagonal-connection-two-cenario1' align="center" >{distance}</div>}
            {idCenario===2 && <div id={444} className='diagonal-connection-two-cenario2' align="center" >{distance}</div>}
        </>
    )
}

export default DiagonalConnectionTwo
